import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';
import { OptionStep } from '../steps/option-step/OptionStep';
import { PickerStep } from '../steps/picker-step/PickerStep';
import { LoadingStep } from '../steps/loading-step/LoadingStep';
import { DiscountScale } from '@photosi/expo-photosi-sdk/build/Project';
import { PickedImage } from '@photosi/expo-photosi-sdk/build/ImageLibrary';
import { BoxStyleInfo, FormatInfo, LookupChoiceForStep } from '@photosi/expo-photosi-sdk/build/PrintUtils';

export enum STEPS {
  Format = 'Format',
  PaperType = 'PaperType',
  PaperFinish = 'PaperFinish',
  Picker = 'Picker',
  Loading = 'Loading',
  BoxStyle = 'BoxStyle',
}

export const StepsToComplete = [STEPS.Format, STEPS.PaperType, STEPS.PaperFinish, STEPS.Picker];
export const StepsToCompleteOnlyPicker = [STEPS.Picker];
export const StepsToCompleteHappyCase = [STEPS.BoxStyle, STEPS.Picker];

export const PickerList = [
  SELECTED_MENU_ITEMS.Computer,
  SELECTED_MENU_ITEMS.GooglePhoto,
  SELECTED_MENU_ITEMS.Smartphone,
  SELECTED_MENU_ITEMS.FamilyFriends,
];

export const PickerListMobile = [
  SELECTED_MENU_ITEMS.Gallery,
  SELECTED_MENU_ITEMS.GooglePhoto,
  SELECTED_MENU_ITEMS.FamilyFriends,
];

export interface StepProps<T> {
  step: STEPS;
  cards: T[];
  onConfirmStep: (error?: boolean, productImages?: PickedImage[], googleAccessToken?: string) => void;
  selectedCard?: string;
  setSelectedCard: (code: string) => void;
  setUploadingPhoto?: (uploading: boolean) => void;
  isUploadingPhoto?: boolean;
  discount?: DiscountScale[];
  selectedFormat?: FormatInfo | BoxStyleInfo | LookupChoiceForStep;
  title: string;
  isHappyCaseGroup?: boolean;
  isPhotokitGroup?: boolean;
  groupCode?: string;
  isOnline: boolean;
}

export const StepUpload = (props: StepProps<any>) => {
  switch (props.step) {
    case STEPS.Format:
      return <OptionStep type={'FormatInfo'} {...props} />;
    case STEPS.Picker:
      return <PickerStep {...props} />;
    case STEPS.Loading:
      return <LoadingStep {...props} />;
    case STEPS.BoxStyle:
      return <OptionStep type={'BoxStyleInfo'} {...props} />;
    case STEPS.PaperType:
      return <OptionStep type={'PaperType'} {...props} />;
    case STEPS.PaperFinish:
      return <OptionStep type={'PaperFinish'} {...props} />;
    default:
      return <></>;
  }
};
